










import { resolveEventEntryPayload } from "@/utils/v3/event.utils";
import { EntryDirection, EventEntryDto } from "@saysimple-platform/dtos";
import { defineComponent, PropType } from "@vue/composition-api";

export default defineComponent({
    props: {
        entry: {
            type: Object as PropType<EventEntryDto>,
            required: true,
        },
        groupDirection: {
            type: String as PropType<EntryDirection>,
            required: false,
        },
    },
    // @ts-ignore
    setup() {
        return {
            resolveEventEntryPayload,
        };
    },
});
